// src/pages/Account/HealthProfilePage.js

import React, { useState, useEffect, useCallback } from "react";
import styled, { keyframes } from "styled-components"; // Import keyframes vì toast dùng animation
import SideNavAccount from "../../components/SideNav/SideNavAccount";
import { useMealMate } from "../../context/MealMateContext";
import api from "../../api";

import {
  Form,
  Input,
  Select,
  Button,
  Spin,

  Checkbox,
  Row,
  Col,
  TimePicker,
} from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const { Option } = Select;
const CheckboxGroup = Checkbox.Group;

const HealthProfilePageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f8f9fa;
`;

const MainContent = styled.div`
  flex: 1;
  padding: 2.5rem 3rem;
  background-color: #f8f9fa;

  h1 {
    font-size: 2.8rem;
    color: #2c3e50;
    margin-bottom: 2.5rem;
    text-align: center;
    font-weight: 700;
    letter-spacing: -0.05rem;
  }
`;

const StyledForm = styled(Form)`
  max-width: 900px;
  margin: 0 auto;
  padding: 2.5rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);

  .ant-form-item-label > label {
    font-weight: 600;
    color: #34495e;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  color: #34495e;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.8rem;
`;

// ======================= Styled Components cho Toast Notifications (ĐƯỢC THÊM TỪ FavoriteListsPage.js) =======================
// Animations (copy từ FavoriteListsPage.js)
const slideInDown = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

const slideOutUp = keyframes`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
`;

const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1001;
`;

const ToastItem = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin-bottom: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 300px;
  animation: ${(props) => (props.isClosing ? slideOutUp : slideInDown)} 0.4s
    ease;
  border-left: 4px solid
    ${(props) =>
      props.type === "success"
        ? "#52c41a"
        : props.type === "error"
        ? "#ff4d4f"
        : "#fa8c16"};
`;

const ToastIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background-color: ${(props) =>
    props.type === "success"
      ? "#52c41a"
      : props.type === "error"
      ? "#ff4d4f"
      : "#fa8c16"};
  color: white;
`;

const ToastMessage = styled.div`
  flex: 1;
  color: #333;
  font-size: 0.9rem;
`;

// ======================= Danh sách các lựa chọn (GIỮ NGUYÊN) =======================
const healthGoalOptions = [
  { label: "Giảm cân", value: "weight_loss" },
  { label: "Tăng cân", value: "weight_gain" },
  { label: "Duy trì cân nặng", value: "maintain_weight" },
  { label: "Ăn uống lành mạnh", value: "healthy_eating" },
  { label: "Tăng cơ", value: "muscle_gain" },
  { label: "Khác", value: "other" },
];

const activityLevelOptions = [
  { label: "Ít vận động (rất ít hoặc không tập thể dục)", value: "sedentary" },
  { label: "Hoạt động nhẹ (tập 1-3 ngày/tuần)", value: "lightly_active" },
  { label: "Hoạt động vừa (tập 3-5 ngày/tuần)", value: "moderately_active" },
  { label: "Hoạt động nhiều (tập 6-7 ngày/tuần)", value: "very_active" },
  { label: "Vận động viên (tập 2 lần/ngày)", value: "super_active" },
];

const dietaryPreferenceOptions = [
  { label: "Ăn chay (Vegetarian)", value: "vegetarian" },
  { label: "Thuần chay (Vegan)", value: "vegan" },
  { label: "Keto", value: "keto" },
  { label: "Paleo", value: "paleo" },
  { label: "Không Gluten (Gluten-free)", value: "gluten_free" },
  { label: "Không sữa (Dairy-free)", value: "dairy_free" },
  { label: "Ăn cá (Pescatarian)", value: "pescatarian" },
  { label: "Không thịt đỏ (No red meat)", value: "no_red_meat" },
  { label: "Halal", value: "halal" },
  { label: "Kosher", value: "kosher" },
  { label: "Khác", value: "other" },
];

const allergyOptions = [
  { label: "Gluten", value: "gluten" },
  { label: "Sữa", value: "dairy" },
  { label: "Hạt cây (hạnh nhân, óc chó...)", value: "nuts" },
  { label: "Lạc (đậu phộng)", value: "peanuts" },
  { label: "Hải sản có vỏ (tôm, cua...)", value: "shellfish" },
  { label: "Trứng", value: "eggs" },
  { label: "Đậu nành", value: "soy" },
  { label: "Cá", value: "fish" },
  { label: "Vừng (mè)", value: "sesame" },
  { label: "Thịt bò", value: "beef" },
  { label: "Thịt lợn", value: "pork" },
  { label: "Thịt gà", value: "chicken" },
  { label: "Không có dị ứng nào", value: "none" },
  { label: "Khác", value: "other" },
];

const healthConditionOptions = [
  { label: "Không có bệnh lý nền", value: "none" },
  { label: "Tiểu đường", value: "diabetes" },
  { label: "Huyết áp cao", value: "hypertension" },
  { label: "Bệnh tim mạch", value: "heart_disease" },
  { label: "Bệnh thận", value: "kidney_disease" },
  { label: "Vấn đề tiêu hóa", value: "digestive_issues" },
  { label: "Khác", value: "other" },
];

const mealCountOptions = [1, 2, 3, 4, 5, 6].map((num) => ({
  label: `${num} bữa`,
  value: num,
}));

const HealthProfilePage = () => {
  const {  updateUserProfile: updateContextUserProfile } = useMealMate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [showOtherAllergiesInput, setShowOtherAllergiesInput] = useState(false);
  const [showOtherHealthConditionsInput, setShowOtherHealthConditionsInput] =
    useState(false);

  // State cho Toast Notifications (ĐƯỢC THÊM TỪ FavoriteListsPage.js)
  const [toasts, setToasts] = useState([]);

  // Hàm showToast (ĐƯỢC THÊM TỪ FavoriteListsPage.js)
  const showToast = useCallback((message, type = "success") => {
    const id = Date.now();
    const newToast = { id, message, type, isClosing: false };
    setToasts((prev) => [...prev, newToast]);

    // Auto remove after 4 seconds
    setTimeout(() => {
      setToasts((prev) =>
        prev.map((toast) =>
          toast.id === id ? { ...toast, isClosing: true } : toast
        )
      );

      setTimeout(() => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
      }, 400); // 400ms after slideOutUp animation
    }, 4000);
  }, []);

  const fetchUserProfile = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get("/users/profile");
      const userData = response.data?.data;


      let formData = { ...userData };

      if (formData.date_of_birth) {
        formData.date_of_birth = dayjs(formData.date_of_birth);
      } else {
        formData.date_of_birth = null;
      }

      formData.dietaryPreferences = Array.isArray(formData.dietaryPreferences)
        ? formData.dietaryPreferences
        : [];
      formData.allergies = Array.isArray(formData.allergies)
        ? formData.allergies
        : [];
      formData.healthConditions = Array.isArray(formData.healthConditions)
        ? formData.healthConditions
        : [];

      let preferredMealTimesObj = {};
      if (userData.preferredMealTimes instanceof Map) {
        preferredMealTimesObj = Object.fromEntries(userData.preferredMealTimes);
      } else if (
        typeof userData.preferredMealTimes === "object" &&
        userData.preferredMealTimes !== null
      ) {
        preferredMealTimesObj = { ...userData.preferredMealTimes };
      } else {
        preferredMealTimesObj = {
          breakfast: "07:00",
          lunch: "12:00",
          dinner: "19:00",
          snack: "15:00",
        };
      }

      Object.keys(preferredMealTimesObj).forEach((key) => {
        if (
          typeof preferredMealTimesObj[key] === "string" &&
          preferredMealTimesObj[key].match(/^\d{2}:\d{2}$/)
        ) {
          preferredMealTimesObj[key] = dayjs(
            preferredMealTimesObj[key],
            "HH:mm"
          );
        } else {
          preferredMealTimesObj[key] = null;
        }
      });
      formData.preferredMealTimes = preferredMealTimesObj;

      if (
        formData.mealCountPerDay === undefined ||
        formData.mealCountPerDay === null
      ) {
        formData.mealCountPerDay = 3;
      }

      setShowOtherAllergiesInput(formData.allergies.includes("other"));
      setShowOtherHealthConditionsInput(
        formData.healthConditions.includes("other")
      );

      form.setFieldsValue(formData);
    } catch (error) {
      console.error("❌ Lỗi khi tải hồ sơ người dùng:", error);
      // Sử dụng showToast thay vì message.error
      showToast("Không thể tải hồ sơ. Vui lòng thử lại.", "error");
    } finally {
      setLoading(false);
    }
  }, [form, showToast]); // Thêm showToast vào dependencies

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  const onFinish = async (values) => {
    setSubmitting(true);
    try {
      const dataToSend = {
        ...values,
        date_of_birth: values.date_of_birth
          ? values.date_of_birth.toISOString()
          : null,
      };

      if (dataToSend.preferredMealTimes) {
        for (const key in dataToSend.preferredMealTimes) {
          if (dayjs.isDayjs(dataToSend.preferredMealTimes[key])) {
            dataToSend.preferredMealTimes[key] =
              dataToSend.preferredMealTimes[key].format("HH:mm");
          }
        }
      }

      const response = await api.patch("/users/update-profile", dataToSend);

      if (response.data.user) {
        updateContextUserProfile(response.data.user);
        sessionStorage.setItem("userInfo", JSON.stringify(response.data.user)); // <-- DÒNG BẠN CẦN THÊM
      }

      const successMessage =
        response.data.message || "Hồ sơ sức khỏe đã được cập nhật thành công!";

      // SỬ DỤNG showToast THAY VÌ notification.success
      showToast(successMessage, "success");
    } catch (error) {
      console.error("❌ Lỗi khi cập nhật hồ sơ sức khỏe:", error);

      const errorMessage =
        error.response?.data?.message ||
        "Cập nhật hồ sơ thất bại. Vui lòng thử lại.";

      // SỬ DỤNG showToast CHO LỖI
      showToast(errorMessage, "error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleAllergiesChange = (checkedValues) => {
    setShowOtherAllergiesInput(checkedValues.includes("other"));
    if (checkedValues.includes("none")) {
      form.setFieldsValue({ allergies: ["none"], otherAllergies: "" });
      setShowOtherAllergiesInput(false);
    } else {
      const filteredValues = checkedValues.filter((val) => val !== "none");
      form.setFieldsValue({ allergies: filteredValues });
    }
  };

  const handleHealthConditionsChange = (checkedValues) => {
    setShowOtherHealthConditionsInput(checkedValues.includes("other"));
    if (checkedValues.includes("none")) {
      form.setFieldsValue({
        healthConditions: ["none"],
        otherHealthConditions: "",
      });
      setShowOtherHealthConditionsInput(false);
    } else {
      const filteredValues = checkedValues.filter((val) => val !== "none");
      form.setFieldsValue({ healthConditions: filteredValues });
    }
  };

  if (loading) {
    return (
      <HealthProfilePageWrapper>
        <SideNavAccount />
        <MainContent
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="large" tip="Đang tải hồ sơ..." />
        </MainContent>
      </HealthProfilePageWrapper>
    );
  }

  return (
    <div>
      {" "}
      {/* Bỏ div class="custom-message-debug" nếu không cần nữa */}
      <HealthProfilePageWrapper>
        <SideNavAccount />
        <MainContent>
          <h1>Hồ sơ Sức khỏe & Cá nhân hóa</h1>
          <StyledForm form={form} layout="vertical" onFinish={onFinish}>
            <SectionTitle>Mục tiêu & Hoạt động</SectionTitle>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="healthGoal"
                  label="Mục tiêu sức khỏe chính của bạn là gì?"
                >
                  <Select placeholder="Chọn mục tiêu">
                    {healthGoalOptions.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="activityLevel"
                  label="Mức độ hoạt động thể chất của bạn?"
                >
                  <Select placeholder="Chọn mức độ hoạt động">
                    {activityLevelOptions.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <SectionTitle>Chế độ ăn uống & Dị ứng</SectionTitle>
            <Form.Item
              name="dietaryPreferences"
              label="Bạn có bất kỳ sở thích/chế độ ăn kiêng nào không?"
            >
              <CheckboxGroup options={dietaryPreferenceOptions} />
            </Form.Item>

            <Form.Item
              name="allergies"
              label="Bạn có dị ứng với thực phẩm nào không?"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn ít nhất một tùy chọn dị ứng.",
                },
              ]}
            >
              <CheckboxGroup
                options={allergyOptions}
                onChange={handleAllergiesChange}
              />
            </Form.Item>
            {showOtherAllergiesInput && (
              <Form.Item
                name="otherAllergies"
                label="Vui lòng liệt kê các dị ứng khác của bạn:"
              >
                <Input placeholder="Ví dụ: Đào, cà chua" />
              </Form.Item>
            )}

            <SectionTitle>Tình trạng sức khỏe</SectionTitle>
            <Form.Item
              name="healthConditions"
              label="Bạn có bất kỳ bệnh lý nền nào không?"
            >
              <CheckboxGroup
                options={healthConditionOptions}
                onChange={handleHealthConditionsChange}
              />
            </Form.Item>
            {showOtherHealthConditionsInput && (
              <Form.Item
                name="otherHealthConditions"
                label="Vui lòng liệt kê các bệnh lý khác của bạn:"
              >
                <Input placeholder="Ví dụ: Thiếu máu, Gout" />
              </Form.Item>
            )}

            <SectionTitle>Kế hoạch bữa ăn</SectionTitle>
            <Form.Item
              name="mealCountPerDay"
              label="Bạn muốn ăn bao nhiêu bữa mỗi ngày?"
            >
              <Select placeholder="Chọn số bữa">
                {mealCountOptions.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label="Thời gian các bữa ăn yêu thích của bạn:">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name={["preferredMealTimes", "breakfast"]}
                    label="Bữa sáng"
                    noStyle
                  >
                    <TimePicker
                      format="HH:mm"
                      minuteStep={15}
                      placeholder="Chọn giờ"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name={["preferredMealTimes", "lunch"]}
                    label="Bữa trưa"
                    noStyle
                  >
                    <TimePicker
                      format="HH:mm"
                      minuteStep={15}
                      placeholder="Chọn giờ"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} style={{ marginTop: "1rem" }}>
                <Col span={12}>
                  <Form.Item
                    name={["preferredMealTimes", "dinner"]}
                    label="Bữa tối"
                    noStyle
                  >
                    <TimePicker
                      format="HH:mm"
                      minuteStep={15}
                      placeholder="Chọn giờ"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name={["preferredMealTimes", "snack"]}
                    label="Bữa ăn nhẹ"
                    noStyle
                  >
                    <TimePicker
                      format="HH:mm"
                      minuteStep={15}
                      placeholder="Chọn giờ"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item style={{ textAlign: "right", marginTop: "2rem" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={submitting}
                style={{ backgroundColor: "#6a8bad", borderColor: "#6a8bad" }}
              >
                Lưu hồ sơ sức khỏe
              </Button>
            </Form.Item>
          </StyledForm>
        </MainContent>
        {/* Toast Notifications JSX (ĐƯỢC THÊM TỪ FavoriteListsPage.js) */}
        <ToastContainer>
          {toasts.map((toast) => (
            <ToastItem
              key={toast.id}
              type={toast.type}
              isClosing={toast.isClosing}
            >
              <ToastIcon type={toast.type}>
                {toast.type === "success"
                  ? "✓"
                  : toast.type === "error"
                  ? "✕"
                  : "!"}
              </ToastIcon>
              <ToastMessage>{toast.message}</ToastMessage>
            </ToastItem>
          ))}
        </ToastContainer>
      </HealthProfilePageWrapper>
    </div>
  );
};

export default HealthProfilePage;
